import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlumniIntroComponent } from 'src/app/view/alumni/alumni-intro/alumni-intro.component';
import { AlumniComponent } from 'src/app/view/alumni/alumni.component';
import { RouterModule } from '@angular/router';
import { LoaderModule } from '../loader/loader.module';
import { SharedModule } from '../shared/shared.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AlumniPrincipalMessageComponent } from 'src/app/view/alumni/alumni-principal-message/alumni-principal-message.component';
import { AlumniFormComponent } from 'src/app/view/alumni/alumni-form/alumni-form.component';
import { AlumniAssociationComponent } from 'src/app/view/alumni/alumni-association/alumni-association.component';



@NgModule({
  declarations: [
    AlumniComponent,
    AlumniIntroComponent,
    AlumniPrincipalMessageComponent,
    AlumniFormComponent,
    AlumniAssociationComponent



  ],
  imports: [
    CommonModule,
    LoaderModule,
    PdfViewerModule,
    SharedModule,
    RouterModule.forChild([
      {
        path: '', component: AlumniComponent, children: [
          { path: 'institutional-message', component: AlumniIntroComponent },
          { path: 'principal-message', component: AlumniPrincipalMessageComponent },
          { path: 'alumni-form', component: AlumniFormComponent },
          { path: 'alumni-association', component: AlumniAssociationComponent }
        ]
      }
    ])
  ]
})
export class AlumniModule { }
